<script>
export default {
  // Disable automatic attribute inheritance, so that $attrs are
  // passed to the <input>, even if it's not the root element.
  // https://vuejs.org/v2/guide/components-props.html#Disabling-Attribute-Inheritance
  inheritAttrs: false,
  // Change the v-model event name to `update` to avoid changing
  // the behavior of the native `input` event.
  // https://vuejs.org/v2/guide/components-custom-events.html#Customizing-Component-v-model
  model: {
    event: 'update',
  },
  props: {
    error: {
      type: String,
      default: '',
      required: false,
    },
    labelContent: {
      type: String,
      required: false,
      default: '',
    },
    markRequired: {
      type: Boolean,
      default: false,
    },
    id: {
      type: String,
      default: '',
      required: false,
    },
    isDisabled: {
      type: Boolean,
      default: false,
      required: false,
    },
    maskker: {
      type: String,
      default: '',
      required: false,
    },
    formatter: {
      type: String,
      default: '',
      required: false,
    },
    validattor: {
      type: String,
      default: '',
      required: false,
    },
    type: {
      type: String,
      default: 'text',
      // Only allow types that essentially just render text boxes.
      validator(value) {
        return [
          'email',
          'number',
          'password',
          'search',
          'tel',
          'text',
          'url',
        ].includes(value)
      },
    },
  },
  methods: {
    newFormatter(value, event) {
      let validChars = new RegExp(this.maskker)
      let _tempStr = value.replace(/\s+/g, ' ')
      return _tempStr.replace(validChars, this.formatter)
    },
    onInputKeyPress: function(event) {
      if (this.validattor !== '') {
        let validChars = new RegExp(this.validattor)
        let keyChar = String.fromCharCode(event.which || event.keyCode)
        let ans = validChars.test(keyChar) ? keyChar : false
        if (ans === false) {
          event.preventDefault()
          return false
        }
      }
    },
    onLostFocus: function(event) {
      let _tempStr = event.target.value.replace(/\s+/g, ' ')
      this.$emit('update', _tempStr.trim())
    },
  },
}
</script>

<template>
  <div>
    <div v-if="labelContent">
      <BaseELabel
        :label="labelContent"
        :mark-required="markRequired"
        :for="id"
      />
    </div>
    <input
      v-if="maskker === ''"
      :id="id"
      :type="type"
      aria-autocomplete="off"
      class="form-control mb-1"
      :class="$style.input"
      v-bind="$attrs"
      :disabled="isDisabled"
      v-on="$listeners"
      @input="$emit('update', $event.target.value.trim())"
      @keypress="onInputKeyPress"
      @blur="onLostFocus"
    />

    <b-form-input
      v-if="maskker !== ''"
      :id="id"
      type="text"
      aria-autocomplete="off"
      class="form-control mb-1"
      :class="$style.input"
      v-bind="$attrs"
      :disabled="isDisabled"
      data-xtype="text"
      :formatter="newFormatter"
      v-on="$listeners"
      @input="$emit('update', $event)"
      @keypress="onInputKeyPress"
    />
  </div>
</template>
<style lang="scss" module>
@import '@design';

.input {
  display: block;
  width: 100%;
  margin-bottom: $size-grid-padding;
  background-color: $color-content-bg;
  border: $size-input-border solid $color-input-border;
  border-radius: $size-input-border-radius;
}
</style>
